import {LuminousGallery} from "luminous-lightbox";

export default class Gallery {

	constructor(galleryElement) {
		new LuminousGallery(galleryElement.querySelectorAll('a'));
	}

}

